// src/Routes/Tools/config/flashcardConfig.ts
import { ToolConfig } from "../../../Components/HighLevelComponents/Tool/types";
import FlashcardRenderer from "../../../Components/HighLevelComponents/Tool/renderers/FlashcardRenderer";

const flashcardConfig: ToolConfig = {
  id: "flashcards",
  title: "Flashcard Generator",
  description:
    "Transform your study material into flashcards with front and back sides for effective memorization.",
  inputs: [
    {
      id: "text-input",
      name: "text",
      label: "Source Text",
      description: "Enter the text you want to create flashcards from",
      type: "textarea",
      required: true,
      placeholder: "Paste your text here...",
    },
    // Note: count and difficulty are handled by the Tool component directly
  ],
  promptId: 12, // ID of the flashcard generator prompt (adjust if your ID is different)
  resultRenderer: FlashcardRenderer,
};

export default flashcardConfig;
